module.exports = __webpack_public_path__ + "static/media/license_import_template.31dc5f35.csv";